export function makeSentryReleaseName(name: string, version: string): string {
  const _name = name.replace('@qii/', '');
  return `${_name}@${version}`;
}
